import utilsStyles from '../../../styles/modules/utils.module.scss';
import TextAlert from '../TextAlert/TextAlert';

export type UnRegisteredAddressAlertProps = {
  handleGoMainAddress: (e: React.MouseEvent) => void;
};

function UnRegisteredAddressAlert({ handleGoMainAddress }: UnRegisteredAddressAlertProps) {
  return (
    <TextAlert>
      住所が未登録です。
      {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
      <a href='#' onClick={handleGoMainAddress} className={utilsStyles.textUnderlined}>
        こちら
      </a>
      から住所を登録してください。
    </TextAlert>
  );
}

export default UnRegisteredAddressAlert;
